import { Layout } from "../UI/Layout/Layout.tsx";
import { ScreenTitleBlock } from "../UI/Layout/ScreenTitleBlock.tsx";
import { BreadCrumbsWrapper } from "../UI/Layout/BreadCrumbsWrapper.tsx";
import { BreadCrumbsItem } from "../UI/Layout/BreadCrumbsItem.tsx";
import { Card } from "../UI/Card.tsx";
import { ErrorMessagePopup } from "../UI/MessagePopup/ErrorMessagePopup.tsx";
import { useMessagePopupController } from "../UI/MessagePopup/useMessagePopupController.ts";
import { useNavigate } from "react-router-dom";
import { ApolloError } from "@apollo/client";
import { UserGroupForm, UserGroupFormInputs } from "./UserGroupForm.tsx";
import { useCreateUserGroup } from "./useCreateUserGroup.ts";
import { useToAllUserGroups } from "./useToAllUserGroups.ts";

export const CreateUserGroupScreenPath = "/user-groups/new";

export function CreateUserGroupScreen() {
  const { toAllUserGroups } = useToAllUserGroups();
  const { createUserGroup } = useCreateUserGroup();
  const { show, title, description, showPopup } = useMessagePopupController(
    4 * 1000,
  );
  const navigate = useNavigate();

  async function onSave(data: UserGroupFormInputs) {
    try {
      await createUserGroup({
        name: data.name,
        thinkificBundleId: data.thinkificBundleId,
        availability: data.availability,
        onboardingLiveRequired: data.onboardingLiveRequired,
        onboardingLiveBookingWindowDays: data.onboardingLiveBookingWindowDays,
      });
    } catch (e) {
      const error = e as ApolloError;
      showPopup("Error", error?.message ?? "Unknown error");
      return;
    }
    navigate(-1);
  }

  return (
    <>
      <ErrorMessagePopup title={title} description={description} show={show} />
      <Layout>
        <Card>
          <ScreenTitleBlock
            title={"New user group"}
            breadCrumbs={
              <BreadCrumbsWrapper>
                <BreadCrumbsItem
                  onClick={toAllUserGroups}
                  title={"User Groups"}
                />
                <BreadCrumbsItem title={"New group"} />
              </BreadCrumbsWrapper>
            }
          />
        </Card>
        <div className={"mt-4"}>
          <Card>
            <UserGroupForm onSave={onSave} />
          </Card>
        </div>
      </Layout>
    </>
  );
}
